import React, { Fragment } from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import Contacts from './Contacts';


function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const styles = theme => ({
  root: {
    flexGrow: 1, 
    //minHeight: 400,
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
    marginBottom: theme.spacing.unit * 2,
   },
   tabsIndicator: {
     backgroundColor: '#1F2833',
   },
   tabRoot: {
     border: '1px solid #C5C6C7',
     textTransform: 'initial',
     fontWeight: 'bold',
     marginRight: theme.spacing.unit * 4,
     fontFamily: [
       '-apple-system',
       'BlinkMacSystemFont',
       '"Segoe UI"',
       'Roboto',
       '"Helvetica Neue"',
       'Arial',
       'sans-serif',
       '"Apple Color Emoji"',
       '"Segoe UI Emoji"',
       '"Segoe UI Symbol"',
     ].join(','),
     '&:hover': {
    //   color: '#0B0C10',
       opacity: 1,
     },
     '&:focus': {
     //  color: '#0B0C10',
     },
   },
    tabSelectedLight: {
      color: '#1F2833',
      fontWeight: 'bold',
      backgroundColor:'#00FEE6',
      border: '0px solid #00FEE6',
    },
    tabSelectedDark: {
      color: '#00FEE6',
      fontWeight: 'bold',
      backgroundColor:'#1F2833',
      border: '0px solid #1F2833',
    }
  }
);

@inject("commonStore")
@observer
class Qualifier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        value: 0,
    }
  }
  makeLabel = (value) => {
    const splitArray = value.split('_')
    if(splitArray.length > 1){
      return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
    }
    return jsUcfirst(value)
}
  makeTabs = (value) => {
    const { commonStore, classes, qualifiers } = this.props 

    const { network } = commonStore
    const { types } = network
    const { qualifiers: networkQualifiers } = types

    const sortedQualifiers = networkQualifiers.filter(v => qualifiers.includes(v));
    return sortedQualifiers.map(qualifier => {
        return (<Tab
        key={qualifier}
        disableRipple
        classes={{ root: classes.tabRoot, selected: qualifier === 'standard' ? classes.tabSelectedLight : classes.tabSelectedDark  }}
        label={this.makeLabel(qualifier)}
      />)
    })
  }
  makeTabBody = (value) => {
    const { classes, commonStore, qualifiers, ...otherProps } = this.props;
    if(value < qualifiers.length){
      const qualifier = qualifiers[value]
   
      return (
        <Fragment>
        <Contacts qualifier={qualifier}  {...otherProps} />
      </Fragment>
      )
    }
    return null
  }

  handleTabChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { value } = this.state
    const { classes } = this.props
    return (
      <div className={classes.root}>

            <Tabs
              value={value}
              onChange={this.handleTabChange}
              classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
              >
                   {this.makeTabs()}
            </Tabs>
            {this.makeTabBody(value)}
        </div>
    );
  }
}

Qualifier.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Qualifier);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/Qualifiers.js